import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Accordion as BootstrapAccordion } from 'react-bootstrap'; // JSS

import { RichText } from '@sitecore-jss/sitecore-jss-react'; // Type defintitions

import * as TYPES from '../../types';

var ContentBlockExpand = function ContentBlockExpand(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      alignment = props.alignment,
      copy = props.copy;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var handleToggle = function handleToggle() {
    return setActive(!active);
  };

  var wrapperClass = 'cb-l-copy-wrapper--left';

  if (typeof alignment !== 'undefined' && alignment === 'center') {
    wrapperClass = 'cb-l-copy-wrapper';
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "\n      cb-l-margin-small--top\n      ".concat(wrapperClass, "\n      ")
  }, /*#__PURE__*/React.createElement(BootstrapAccordion, null, /*#__PURE__*/React.createElement(BootstrapAccordion.Toggle, {
    className: "\n            cb-button-toggle\n            ".concat(active ? 'is-active' : '', "\n          "),
    as: "a",
    variant: "link",
    eventKey: "0",
    onClick: handleToggle
  }, copy || "Show ".concat(active ? "Less" : "More")), /*#__PURE__*/React.createElement(BootstrapAccordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-l-content cb-l-margin-xsmall--top"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: model,
    tag: "div"
  })))));
};

export default ContentBlockExpand;